function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.89543 0 2 0H20.5462C22.7553 0 24.5462 1.79086 24.5462 4V37.9661C24.5462 40.1752 22.7553 41.9661 20.5462 41.9661H4C1.79086 41.9661 0 40.1752 0 37.9661V2Z",
  fill: "#040620"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.14954 38.8611L14.8999 33.4066V7.34793L2.14954 1.89346V38.8611Z",
  fill: "#CD6A2D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2534 20.377C12.2534 20.9035 12.6776 21.3299 13.2001 21.3299C13.7232 21.3299 14.1473 20.9035 14.1473 20.377C14.1473 19.851 13.7232 19.4241 13.2001 19.4241C12.6776 19.4241 12.2534 19.851 12.2534 20.377Z",
  fill: "#040620"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.747 31.4992H39.7274L32.0112 17.8843H31.8939V31.4992H28.2556V11.2397H33.3314L40.0504 23.1418H40.1087V11.2397H43.747V31.4992Z",
  fill: "#040620"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.7715 19.9227V16.467L47.204 16.4664V11.7791L51.5194 11.7712V16.467H54.7179V19.9227H51.5194V25.8881C51.5194 27.6305 51.5194 28.3394 53.6028 28.2505L54.9525 28.1917V31.4696L54.659 31.5289C53.8374 31.6469 53.0453 31.7941 52.2531 31.7941C51.0207 31.7941 49.3781 31.6173 48.4098 30.8199C47.2068 29.8155 47.2068 28.0143 47.2068 26.5377V19.9227H44.7715Z",
  fill: "#040620"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.2497 22.1665C65.1619 20.5427 64.6333 19.0364 62.7555 19.0364C60.8488 19.0364 60.115 20.4538 59.9688 22.1665H65.2497ZM59.9977 24.736L59.9688 25.474C59.9688 27.2461 60.9661 28.6937 62.8439 28.6937C64.1641 28.6937 65.4843 27.7189 65.4843 26.3313L69.4745 26.6261C69.4745 27.3642 67.7434 31.7941 62.6971 31.7941C58.2373 31.7941 55.3328 28.664 55.3328 24.2044C55.3328 19.7745 57.9438 16.2012 62.5798 16.2012C64.6627 16.2012 66.8046 17.1463 68.0364 18.8591C69.2688 20.5724 69.5918 22.6981 69.5629 24.736H59.9977Z",
  fill: "#040620"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.7376 16.4966V19.3022H74.7959C75.2362 17.7075 76.1161 16.0535 77.9939 16.2012L78.7283 16.2605V20.6015C75.4419 20.4241 75.0311 23.1122 75.0311 25.77V31.4992H70.7185V16.4966H74.7376Z",
  fill: "#040620"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M95.3793 31.4992H91.3592L83.6435 17.8843H83.5262V31.4992H79.8879V11.2397H84.9637L91.6827 23.1418H91.7411V11.2397H95.3793V31.4992Z",
  fill: "#040620"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.991 23.5251C100.991 25.2385 100.963 28.9007 103.427 28.9007C105.862 28.9007 105.979 25.9468 105.979 24.1451C105.979 22.9639 105.921 21.5466 105.51 20.4241C105.157 19.4499 104.453 19.0655 103.456 19.0655C101.138 19.0655 100.991 21.8129 100.991 23.5251ZM110.615 24.116C110.615 28.3982 107.828 31.7941 103.427 31.7941C98.8496 31.7941 96.3553 28.3098 96.3553 23.9683C96.3553 19.5977 98.8791 16.2012 103.427 16.2012C108.092 16.2012 110.615 19.6861 110.615 24.116Z",
  fill: "#040620"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.769 31.4992H122.896L120.578 21.8717H120.52L118.202 31.4992H114.505L109.898 16.4966H114.505L116.881 25.6816H116.94L119.2 16.4966H123.16L125.302 25.7107H125.36L127.855 16.4966H131.258L126.769 31.4992Z",
  fill: "#040620"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.599 16.8911H133.103V18.4875H132.641V16.8911H132.139V16.4966H133.599V16.8911Z",
  fill: "#040620"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M135.037 18.4875H134.72L134.238 16.8654H134.232V18.4875H133.843V16.4966H134.567L134.913 17.689L135.276 16.4966H136V18.4875H135.539V16.8654H135.527L135.037 18.4875Z",
  fill: "#040620"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 42,
    viewBox: "0 0 136 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.31c5bf8a.svg";
export { ForwardRef as ReactComponent };